export const getRole = () => {
  return isProApp() ? "guide_user" : "user"
}

export const isProApp = () => {
  const hostName = window.location.host
  return hostName === process.env.REACT_APP_PRO_HOST
}
